/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_Next_EventInputs */



/**
* | output |
* | --- |
* | "Select the next event in the list" |
*
* @param {Shortcut_Keys_Desc_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement suivant dans la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das nächste Ereignis in der Liste aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'evento successivo nell'elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите следующее событие в списке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el próximo evento en la lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择列表中的下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト内の次のイベントを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची में अगला इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o próximo evento da lista.")
	return /** @type {LocalizedString} */ ("Select the next event in the list")
});